import React, { useEffect, useState } from 'react';

import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import './ChooseOrganization.scss';

import InputDropdown from '../../bergmannsoft/components/Widgets/Forms/InputDropdown';
import { UserActions } from '../../store/actions/users';
import { CompanyActions } from '../../store/actions/companies';
import actions from '../../store/actions';

import logo from '../../assets/images/logo-code7-boteria.svg';
import Footer from '../../components/Footer2';

const ChooseOrganization = (props) => {
  const dispatch = useDispatch();

  const isSelectOrg = localStorage.getItem('isSelectOrg');

  const user = useSelector((state) => state.users.signedUser);
  const claimIsRoot = useSelector((state) => state.users.signedUserIsRoot);
  const allCompanies = useSelector((state) => state.companies?.companies || []);
  const organizationsUser = useSelector(
    (state) => state.users?.signedUser?.organizations || []
  );

  const allOrganizations = useSelector(
    (state) => state.companies?.organizations || []
  );

  const [companies, setCompanies] = useState([]);
  const [selectOrganization, setSelectOrganization] = useState('');
  const [selectCompany, setSelectCompany] = useState('');
  const [organizationsCompany, setOrganizationsCompany] = useState('');

  const fetchOrgCompanys = (idCompany) => {
    if (idCompany) {
      let orgArray = [];

      if (claimIsRoot) {
        orgArray = allOrganizations.filter((org) => {
          return org.companyId === idCompany;
        });
      } else {
        orgArray = organizationsUser.filter((org) => {
          return org.companyId === idCompany;
        });
      }
      setOrganizationsCompany(orgArray);
      setSelectOrganization(orgArray[0]);
    }
  };

  useEffect(() => {
    const userEmail = localStorage?.analyticsEmail;
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'UA-162254843-2', {
      custom_map: { dimension1: 'emailResponsible' },
    });
    gtag('event', 'email_dimension', { emailResponsible: userEmail });
  }, []);

  useEffect(() => {
    if (!user?._id) {
      dispatch(UserActions.me());
    } else {
      if (!Array.isArray(allCompanies) || allCompanies.length === 0) {
        dispatch(CompanyActions.getCompanies());
      }

      if (!Array.isArray(allOrganizations) || allOrganizations.length === 0) {
        dispatch(CompanyActions.getOrganizations());
      }
    }
  }, [user, allCompanies]);

  useEffect(() => {
    if (companies?.length === 0 && allCompanies?.length > 0) {
      const result = allCompanies.map((comp) => {
        return {
          ...comp,
          name: `${comp?.fantasyName} - (${comp?.emailResponsible})`,
        };
      });
      setCompanies(result);
    }
  }, [allCompanies, companies]);

  const doLogout = () => {
    dispatch(
      UserActions.selectCompanyOrganization(undefined, undefined, false)
    );

    dispatch(actions.logout());
  };

  const handleChangeCompany = (value) => {
    if (selectCompany._id !== value._id) {
      setSelectCompany(value);
      fetchOrgCompanys(value._id);
    }
  };

  const handleChangeOrganization = (value) => {
    setSelectOrganization(value);
  };

  const handleSelectCompanyOrganization = () => {
    if (selectCompany && selectOrganization) {
      localStorage.setItem('isSelectOrg', false);
      dispatch(
        UserActions.selectCompanyOrganization(
          selectCompany._id,
          selectOrganization._id,
          claimIsRoot
        )
      );
    }
  };

  const renderBody = () => {
    if (
      (user && user.selectedCompany && !claimIsRoot) ||
      (claimIsRoot && isSelectOrg === 'false')
    ) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location },
          }}
        />
      );
    }
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <section className="d-flex justify-content-center logo">
              <img alt="Logo" src={logo} />
            </section>
          </div>
        </div>

        <section className="d-flex justify-content-center">
          <div className="box-auth box-auth--choose-organization">
            <div>
              <div className="box-auth__title">Seja bem-vindo!</div>
              <div className="box-auth__helper-text">
                Sua conta possui mais de uma empresa cadastrada. Selecione a
                empresa e o setor que deseja acessar :
              </div>
              <label>Empresa</label>
              <InputDropdown
                className="settings-content-modal-input"
                placeholder="Selecione a empresa"
                value={selectCompany?.fantasyName || ''}
                dropdownItemsList={companies}
                onChange={(value) => handleChangeCompany(value)}
                styleWidth="100%"
                useSearch
              />
              <label>Setor</label>
              <InputDropdown
                className="settings-content-modal-input"
                placeholder="Selecione o setor"
                value={selectOrganization?.name || ''}
                dropdownItemsList={organizationsCompany}
                onChange={(value) => handleChangeOrganization(value)}
                styleWidth="100%"
                cl
              />
              <div className="float-right mt-3">
                <button
                  type="button"
                  className="btn-selec-org-back"
                  onClick={doLogout}
                >
                  {'< voltar'}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-selec-org-ok"
                  onClick={() => handleSelectCompanyOrganization()}
                  disabled={!selectOrganization || !selectCompany}
                >
                  entrar
                </button>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  };

  return renderBody();
};

export default ChooseOrganization;
